/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string;
  slug: string;
};

/**
 * Export `fetchNewsDetail`.
 */

export async function fetchNewsDetail({ locale, slug }: Query): Promise<any> {
  const endpoint = getApiEndpoint('getNewsExhibitionsDetail', { slug });

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
